var _circle, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoChallenge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF1FA5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.666,
    y: 17.3333,
    width: 13.0667,
    height: 12.1333,
    rx: 4.66667,
    stroke: "white",
    strokeWidth: 1.73333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7324 22.1498L30.8207 20.0083C31.8818 19.2726 33.3324 20.0319 33.3324 21.3231V25.5005C33.3324 26.7871 31.8911 27.5475 30.8292 26.8212L27.7324 24.7032V22.1498Z",
    stroke: "white",
    strokeWidth: 1.73333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChallenge);
export default __webpack_public_path__ + "static/media/video-challenge.1a8a338f45d6b47ae08696892e614459.svg";
export { ForwardRef as ReactComponent };